module.exports = __webpack_public_path__ + "static/media/Security_1_active.6fdafb36.svg";